import styled from "styled-components";
import { Text } from "@gcs/design-system/react";

export const SectionTransparencyContainer = styled.section(({ theme }) => ({
  backgroundColor: theme.color.neutral["07"],
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const SectionTransparencyContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const SectionTransparencyBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const SectionTransparencyTitle = styled.h2(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "700",
  margin: "0",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionTransparencyDescription = styled.p(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "160%",
  margin: 0,
  color: theme.color.neutral["02"],

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },

  a: {
    textDecoration: "none",
  },
}));

export const TransparencyItemContainer = styled.div(() => ({
  display: "flex",
  gap: "60px",
}));

export const TransparencyItemContent = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "16px",
  flex: 1,
}));

export const TransparencyItemText = styled(Text)(({ theme }) => ({
  fontWeight: "400",
  color: theme.color.neutral["02"],
  lineHeight: "160%",
  fontSize: "18px",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));
